module.exports = __webpack_public_path__ + "static/media/icon_countdown.f2c3abd1.png";